import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { WorkspaceOwner } from '../../../../team/useWorkspaceOwner';
import { teamOwnerMessages } from '../../../../team/teamOwnerMessages';
import { upgradeMessages } from '../../SMLUpgradeModal/upgradeMessages';
import styles from './PricingMemberNotice.module.scss';

interface PricingMemberNoticeProps {
  owner: WorkspaceOwner;
}

/**
 * The dashed note above the plans (design plans-page a2, o5) for a team member: it names the workspace and the
 * owner who chooses the plan, in place of a checkout button on every card.
 */
const PricingMemberNoticeComponent: React.FC<PricingMemberNoticeProps> = ({ owner }) => {
  const intl = useIntl();

  return (
    <div role="note" className={styles.memberNotice} data-clarity-mask="true">
      <b>{intl.formatMessage(upgradeMessages.memberCta)}</b>{' '}
      {intl.formatMessage(teamOwnerMessages.worksIn, { workspace: owner.workspaceName })}{' '}
      {intl.formatMessage(teamOwnerMessages.choosesPlan, { email: owner.email })}
    </div>
  );
};

export const PricingMemberNotice = TypedMemo(PricingMemberNoticeComponent);
